export const WORKSPACE_STAGE_IDS = [
  'initiation',
  'quotes',
  'invoices',
  'supplier',
  'implementation',
  'aftercare',
] as const;

export type WorkspaceStageId = (typeof WORKSPACE_STAGE_IDS)[number];

export const WORKSPACE_STAGES: Array<{ id: WorkspaceStageId; n: string; label: string }> = [
  { id: 'initiation', n: '1', label: 'Overview' },
  { id: 'quotes', n: '2', label: 'Quotes / Estimates' },
  { id: 'invoices', n: '3', label: 'Invoices' },
  { id: 'supplier', n: '4', label: 'Ordering' },
  { id: 'implementation', n: '5', label: 'Installation' },
  { id: 'aftercare', n: '6', label: 'Aftercare' },
];

export function isWorkspaceStageId(value: string | undefined): value is WorkspaceStageId {
  return !!value && (WORKSPACE_STAGE_IDS as readonly string[]).includes(value);
}

export const EVENT_LINKED_TASKS: Record<string, string> = {
  'First Survey Complete': 'firstSurveyAppointmentConfirmation',
  'Final Survey Complete': 'finalSurveyAppointmentConfirmation',
  'Schedule Installation Date': 'installationDateConfirmation',
  'Schedule Delivery Date': 'deliveryDateConfirmation',
};

export function taskNameForLinkedEvent(eventType: string): string | undefined {
  return Object.entries(EVENT_LINKED_TASKS).find(([, type]) => type === eventType)?.[0];
}
